/*
 * Studio Love You — canlı gösterge para birimi dönüştürücü.
 * Gerçek ödeme her zaman TL olarak alınır; bu sadece müşteriye
 * o anki güncel kurla YAKLAŞIK fiyatı göstermek içindir.
 * Ücretsiz, API anahtarı gerektirmeyen açık kur servisi kullanılır.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sly_currency';
  var STORAGE_LANG_KEY = 'sly_currency_lang';
  var RATES_CACHE_KEY = 'sly_fx_rates_v1';
  var RATES_TTL_MS = 6 * 60 * 60 * 1000; // 6 saat
  var RATES_URL = 'https://open.er-api.com/v6/latest/TRY';

  var CURRENCY_META = {
    TRY: { symbol: 'TL', locale: 'tr-TR', position: 'after' },
    USD: { symbol: '$', locale: 'en-US', position: 'before' },
    EUR: { symbol: '€', locale: 'en-US', position: 'before' },
    RUB: { symbol: '₽', locale: 'en-US', position: 'after' }
  };

  // Dile göre varsayılan para birimi: TR→TL, EN→USD, RU→RUB
  var LANG_CURRENCY_MAP = { tr: 'TRY', en: 'USD', ru: 'RUB' };

  // Bizim money_format'ımız: "{{amount}} TL" (örn. "450.00 TL" veya "1.234,56 TL")
  var PRICE_RE = /(-?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?)\s*TL\b/g;

  function currentLang() {
    var lang = (document.documentElement.lang || 'tr').toLowerCase();
    return lang.slice(0, 2);
  }

  function defaultCurrencyForLang(lang) {
    return LANG_CURRENCY_MAP[lang] || 'TRY';
  }

  function getActiveCurrency() {
    try {
      var lang = currentLang();
      var storedLang = localStorage.getItem(STORAGE_LANG_KEY);
      var stored = localStorage.getItem(STORAGE_KEY);
      // Kullanıcı bu dilde daha önce elle bir kur seçtiyse onu koru;
      // dil değiştiyse (veya hiç seçim yoksa) dile göre varsayılana dön.
      if (stored && storedLang === lang) return stored;
    } catch (e) {}
    return defaultCurrencyForLang(currentLang());
  }

  function setActiveCurrency(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
      localStorage.setItem(STORAGE_LANG_KEY, currentLang());
    } catch (e) {}
  }

  function getCachedRates() {
    try {
      var raw = sessionStorage.getItem(RATES_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.ts > RATES_TTL_MS) return null;
      return parsed.rates;
    } catch (e) {
      return null;
    }
  }

  function setCachedRates(rates) {
    try {
      sessionStorage.setItem(RATES_CACHE_KEY, JSON.stringify({ ts: Date.now(), rates: rates }));
    } catch (e) {}
  }

  var ratesPromise = null;
  function getRates() {
    var cached = getCachedRates();
    if (cached) return Promise.resolve(cached);
    if (ratesPromise) return ratesPromise;
    ratesPromise = fetch(RATES_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.result === 'success' && data.rates) {
          setCachedRates(data.rates);
          return data.rates;
        }
        throw new Error('sly-currency: bad rate response');
      })
      .catch(function () {
        ratesPromise = null;
        return null;
      });
    return ratesPromise;
  }

  function parseTryAmount(rawMatch) {
    // Hem "1.234,56" (Avrupa/TR) hem "1,234.56" (ABD) biçimlerini doğru ayrıştır:
    // ondalık ayraç, sondan itibaren TAM 2 basamak bırakan ayraçtır — hangi
    // sembol (. veya ,) olduğuna bakmadan bunu tespit ederiz, geri kalan
    // ayraçların hepsi binlik ayraç kabul edilip silinir.
    var cleaned = rawMatch.trim();
    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    var decimalPos = Math.max(lastDot, lastComma);
    if (decimalPos > -1 && cleaned.length - decimalPos === 3) {
      var intPart = cleaned.slice(0, decimalPos).replace(/[.,]/g, '');
      var decPart = cleaned.slice(decimalPos + 1);
      return parseFloat(intPart + '.' + decPart);
    }
    return parseFloat(cleaned.replace(/[.,]/g, ''));
  }

  function formatAmount(amount, code) {
    var meta = CURRENCY_META[code];
    var num = amount.toLocaleString(meta.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return meta.position === 'before' ? meta.symbol + num : num + ' ' + meta.symbol;
  }

  var IGNORE_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1 };

  function wrapNewPriceNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || IGNORE_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (parent.closest('.sly-price, .sly-no-convert')) return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || node.nodeValue.indexOf('TL') === -1) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach(function (node) {
      var text = node.nodeValue;
      PRICE_RE.lastIndex = 0;
      if (!PRICE_RE.test(text)) return;
      PRICE_RE.lastIndex = 0;

      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;
      while ((match = PRICE_RE.exec(text))) {
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        var amount = parseTryAmount(match[1]);
        var span = document.createElement('span');
        span.className = 'sly-price';
        if (!isNaN(amount)) {
          span.setAttribute('data-try', amount);
        }
        span.textContent = match[0];
        frag.appendChild(span);
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      node.parentNode.replaceChild(frag, node);
    });
  }

  function applyCurrencyToAll(code) {
    var spans = document.querySelectorAll('.sly-price[data-try]');
    if (!spans.length) return;

    if (code === 'TRY') {
      spans.forEach(function (span) {
        var amount = parseFloat(span.getAttribute('data-try'));
        if (isNaN(amount)) return;
        span.textContent = formatAmount(amount, 'TRY');
      });
      return;
    }

    getRates().then(function (rates) {
      if (!rates || !rates[code]) return;
      var rate = rates[code];
      spans.forEach(function (span) {
        var amount = parseFloat(span.getAttribute('data-try'));
        if (isNaN(amount)) return;
        span.textContent = formatAmount(amount * rate, code);
      });
    });
  }

  var applying = false;

  function refresh() {
    if (applying) return;
    applying = true;
    wrapNewPriceNodes(document.body);
    applyCurrencyToAll(getActiveCurrency());
    window.requestAnimationFrame(function () {
      setTimeout(function () {
        applying = false;
      }, 0);
    });
  }

  var debounceTimer = null;
  function scheduleRefresh() {
    if (applying) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 150);
  }

  function init() {
    refresh();
    var observer = new MutationObserver(function (mutations) {
      if (applying) return;
      var relevant = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length > 0;
      });
      if (relevant) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SLYCurrency = {
    setCurrency: function (code) {
      if (!CURRENCY_META[code]) return;
      setActiveCurrency(code);
      applyCurrencyToAll(code);
    },
    getCurrency: getActiveCurrency
  };
})();
